const S = require('string')

const { createDigitsFromZero } = require('./utils')

const error = (message) => {
	throw new Error(message)
}

module.exports = (hostsAmount, r = 3) => {
	typeof hostsAmount !== 'number' ? error(`Amount of hosts must be defined`) : void 0

	const digits = createDigitsFromZero(r)

	const offset = ((hostsAmount - 1) % r) + 1

	const range = digits.map((i) => {
		const y = offset + i
		return (y > r) ? (y - r) : y
	})

	const hosts = digits.map((i) => {
		const db = hostsAmount - offset + range[i]

		const hostNum = S(db).padLeft(2, '0').s

		return {
			host: `ndb-${ hostNum }`,
			port: 27017 + i
		}
	})

	const repSetNum = S(hostsAmount).padLeft(2, '0').s

	const repSet = `r-${ repSetNum }`

	console.log('HOSTS', hosts)
	console.log('REPSET', repSet)

	return {
		hosts:  hosts,
		repSet
	}
}
